import React from 'react';

import './Banner.scss';

function Banner() {

  const monthlyDownloadDates = JSON.parse(localStorage.getItem('MONTHLY_DOWNLOAD_DATES')).monthlyDownloadDates;

  return (
    <div className="banner-container">
      <h2 className="banner-title">Upcoming monthly download dates:</h2>
      {monthlyDownloadDates.map((date) => (
        <span key={monthlyDownloadDates.indexOf(date)} className='banner-date'>{(new Date(date.downloadDate)).toDateString()}</span>
            ))}
    </div>
  );
}

export default Banner;
